import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ShareModule } from '../share.module';

@Component({
  selector: 'app-notification',
  imports: [ShareModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnChanges {
@Input() notification: Notification = {
    description: '',
    label: '',
    type: '',
  };
 isNotificationVisible: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notification'].currentValue?.['description']) {
      this.isNotificationVisible = true;
    } else {
      this.isNotificationVisible = false;
    }
  }
}

export interface Notification {
  label: string;
  description: string;
  type: string;
}

